import { useEffect, useRef, useState } from "react";
import { Select, message } from "antd";
import "../../../index.css";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../common/customLoader";
import {
  fetchRoleAsDropdownThunk,
  updateRoleThunk,
} from "../../store/thunks/usersThunk";
import { useDispatch } from "react-redux";

const SwitchRole = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const slsRole = secureLocalStorage.getItem("role");
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const formRef = useRef(null);

  /*begin::getRoles will fetch the list of Roles*/
  const getRoles = async () => {
    const payload = {};

    await dispatch(fetchRoleAsDropdownThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((role, index) => {
          temp.push({ label: role?.name, value: role?.name?.toLowerCase() });
        });
        setRoles(temp);
      })
      .catch((error) => {});
  };
  /*end::getRoles will fetch the list of Roles*/

  const handleSubmit = async (event) => {
    event.preventDefault();
    setShowLoader(true);

    const headers = {
      role: slsRole,
    };
    const payload = {
      lIUId: slsLIUId,
      selectedRole,
    };

    await dispatch(updateRoleThunk(payload))
      .unwrap()
      .then((response) => {
        setShowLoader(false);

        resetForm();
        if (response) {
          secureLocalStorage.setItem("role", response?.role);
          message.success(response?.message);
          secureLocalStorage.setItem("switchRole", true);

          navigate("/dashboard");
        }
      })
      .catch((error) => {
        message.error("There was an error!" + error);
        setShowLoader(false);
      });
  };

  const resetForm = () => {
    if (formRef.current) {
      formRef.current.reset();
    }
    setSelectedRole(undefined);
  };

  useEffect(() => {
    getRoles();
  }, []);
  return (
    <div className="all-content switchRoleContainer">
      <div className="logoWrap">
        <CustomLoader showLoader={showLoader} />
        <form onSubmit={handleSubmit} ref={formRef} className="switchRoleForm">
          <div className="switchRoleBody pb-16">
            <label>Role</label>
            <Select
              showSearch
              allowClear
              options={roles}
              value={selectedRole} // Controlled value
              placeholder="Select an option"
              className="w-100"
              onChange={(val) => {
                setSelectedRole(val);
              }}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  ?.toLowerCase()
                  .includes(input?.toLowerCase())
              }
            ></Select>
          </div>
          <div className="settingsButtons">
            <button
              type="button"
              className=" defaultGreyBtn defaultBtn"
              onClick={resetForm}
            >
              Reset
            </button>
            <button
              className="defaultBtn "
              type="submit"
              role="button"
              aria-expanded="false"
              aria-controls="collapseContent"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SwitchRole;
